import { createSlice } from '@reduxjs/toolkit';
import { IDiscount } from 'shared/common/types/discounts';

const initialState: IDiscount[] = [];

const discountsSlice = createSlice({
  initialState,
  name: 'discounts',
  reducers: {},
});

export const { reducer: discountsReducer } = discountsSlice;
